<template>
  <section class="container px-4 xl:px-0">
    <div class="grid gap-3">
      <p class="font-semibold text-xl md:text-6xl font-lato">Характеристики</p>
      <div
        class="w-full h-full shadow-card rounded-2xl p-5 relative sm:text-base text-sm"
      >
        <div class="grid grid-cols-1 gap-x-7 gap-y-4">
          <div v-for="(item, index) in sortAttributes" :key="index">
            <div
              class="grid lg:grid-cols-2 sm:grid-cols-3 grid-cols-12 items-end"
            >
              <div
                class="flex flex-row items-end col-start-1 lg:col-end-2 sm:col-end-3 col-end-8"
              >
                <p class="sm:whitespace-nowrap whitespace-normal">
                  {{ item.name }}
                </p>
                <div
                  class="w-full border-dashed border-b whitespace-nowrap"
                ></div>
              </div>
              <p class="lg:col-start-2 sm:col-start-3 col-start-8 col-end-13">
                {{ item.value }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>
const props = defineProps({
  attributes: {
    type: Array,
    default: [],
  },
});

const sortAttributes = computed(() => {
  if (props.attributes.length) {
    return props.attributes.sort((a, b) => a.priority - b.priority);
  }
  else {
    return []
  }
});
</script>
